import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { Card, Btn, Loader } from "@/components/portal/ui";

export function AccountProfile() {
  const { t } = useI18n();
  const { refreshUser } = useAuth();
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/account").then(({ data }) => setData(data)).catch(() => setData(null)); }, []);
  if (!data) return <Loader />;

  const st = { background: "var(--bg)", borderColor: "var(--border)", borderRadius: "var(--radius)", color: "var(--text)" };

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/account/profile", { name: data.name, contact_phone: data.contact_phone });
      toast.success(t("common.saved"));
      if (refreshUser) refreshUser();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-lg" data-testid="account-profile">
      <Card className="p-6 space-y-4">
        <div className="flex items-center gap-2">
          <UserRound className="h-5 w-5" style={{ color: "var(--accent)" }} />
          <h2 className="font-heading text-lg font-bold" style={{ color: "var(--text)" }}>{t("account.personalData")}</h2>
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>{t("account.name")}</label>
          <input data-testid="account-name-input" className="w-full px-3.5 h-11 text-sm border outline-none" style={st}
            value={data.name || ""} onChange={(e) => setData({ ...data, name: e.target.value })} />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>{t("account.email")}</label>
          <input data-testid="account-email-input" disabled className="w-full px-3.5 h-11 text-sm border outline-none opacity-60" style={st} value={data.email || ""} />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>{t("account.phone")}</label>
          <input data-testid="account-phone-input" className="w-full px-3.5 h-11 text-sm border outline-none" style={st}
            value={data.contact_phone || ""} onChange={(e) => setData({ ...data, contact_phone: e.target.value })} />
        </div>
        <Btn onClick={save} disabled={saving} className="w-full" data-testid="account-save-btn">{t("common.save")}</Btn>
      </Card>
    </div>
  );
}
